import { createConfig } from '@ygoargentina/config';

const Config = createConfig();

export default Config;
